//Caesar cipher
function rot13(str) { // LBH QVQ VG!
	var newstr = [];
	for (var i = 0; i < str.length; ++i) {
		if (str.charCodeAt(i) < 65 || str.charCodeAt(i) > 90) {
			if (str.charCodeAt(i) <= 109 && str.charCodeAt(i) >= 97) {
				newstr.push(String.fromCharCode(str.charCodeAt(i) + 13));
			} else if (str.charCodeAt(i) <= 122 && str.charCodeAt(i) >= 109) {
				newstr.push(String.fromCharCode(str.charCodeAt(i) - 13));
			} else newstr.push(str[i]);
		} else if (str.charCodeAt(i) <= 77) {
			newstr.push(String.fromCharCode(str.charCodeAt(i) + 13));
		} else {
			newstr.push(String.fromCharCode(str.charCodeAt(i) - 13));
		}
	}
	return newstr.join('');
}

function StrUp(str) {
	return str.toUpperCase().trim();
}
//url解密
function decodeurl(str) {
	return decodeURIComponent(str)
}
//url加密
function encodeurl(str) {
	return encodeURIComponent(str)
}
export function encode(str) {
	let strnew = encodeurl(str);
	strnew = rot13(strnew);
	return strnew;
}
export function decode(str) {
	let strnew = rot13(str);
	strnew = decodeurl(strnew);
	return strnew;
}
